import React from 'react';
import { Link } from 'react-router-dom';
import ResponsiveImage from '../../../responsive-image/ResponsiveImage';

type Props = {
  image: string;
  title: string;
  description: string;
  to: string;
};

export default function QuickAccessCard({
  image,
  title,
  description,
  to,
}: Props) {
  return (
    <Link
      to={to}
      className="block w-full sm:max-w-80 bg-background rounded-lg border border-border p-3 space-y-4"
    >
      <ResponsiveImage
        aspectRatio={4 / 3}
        className="rounded-md"
        src={image}
        alt={`${title} image`}
      />
      <div className="space-y-1">
        <p className="hig-emphasis-text max-w-full capitalize font-medium">
          {title}
        </p>
        <small className="block medium-emphasis-text max-w-full leading-normal font-normal">
          {description}
        </small>
      </div>
    </Link>
  );
}
